import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { HOST } from 'config/config';
import useToast from 'services/Hooks/useToast';

export const useCartWalls = cartId => {
  const { errorMessage } = useToast();
  const query = useQuery({
    queryKey: ['cartWalls', cartId],
    queryFn: async () => {
      const response = await axios.get(`${HOST}/api/dealer-portal/cart-walls?cartId=${cartId}`);
      return response.data;
    },
    refetchOnWindowFocus: 'always',
    throwOnError: errorMessage,
  });
  return query;
};

export const usePostCalculateCartWall = () => {
  const { errorMessage } = useToast();
  const queryClient = useQueryClient();
  const query = useMutation({
    mutationKey: ['postCartWall'],
    mutationFn: async wall => {
      return await axios.post(`${HOST}/api/dealer-portal/cart-walls/get-pricing`, wall);
    },
    onSuccess: ({ data: wall }) => {
      queryClient.setQueryData(['calculatedWall'], wall);
    },
    onError: errorMessage,
  });
  return query;
};
